import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'android-button',
  templateUrl: './android-button.component.html'
})
export class AndroidButtonComponent implements OnInit {
  constructor() { }

  ngOnInit() {

  }

}
